<template>
  <div>
    <label
      v-if="label"
      v-text="label"
      class="mb-1 block text-sm font-medium leading-5 text-gray-700"
    />
    <slim-cropper ref="slim" :options="slimOptions">
      <input type="file" name="slim" />
    </slim-cropper>
    <p class="mt-2 text-sm text-red-600" v-if="hasError" v-text="error[0]" />
  </div>
</template>


<script>
import SlimCropper from "@/components/slim/slim.vue";
import filesClient from "@/api/central/files";

export default {
  components: { SlimCropper },

  props: {
    value: {
      required: false
    },
    forceSize: {
      required: true
    },
    label: {
      required: false,
      default: null
    },
    error: {
      required: false,
      default: null
    }
  },

  computed: {
    hasError() {
      return !!this.error;
    }
  },

  data() {
    return {
      file: null,
      slimOptions: {
        post: "input, output",
        forceSize: this.forceSize,
        label: "Ziehe ein Bild hierher oder durchsuche dein Gerät.",
        buttonConfirmLabel: "Bestätigen",
        buttonCancelLabel: "Abbrechen",
        statusFileType: "Ungültiger Dateityp, erwartet: $0.",
        statusFileSize: "Datei ist zu Groß. Maximum ist $0 MB.",
        statusNoSupport: "Ihr Browser unterstützt das Zuschneiden von Bildern nicht.",
        statusImageTooSmall: "Das Bild ist zu klein, die Mindestgröße beträgt: $0 Pixel.",
        statusContentLength: '<span class="slim-upload-status-icon"></span> Die Datei ist wahrscheinlich zu groß.',
        statusUnknownResponse: '<span class="slim-upload-status-icon"></span> Ein unbekannter Fehler ist aufgetreten',
        statusUploadSuccess: '<span class="slim-upload-status-icon"></span> Hochgeladen',
        service: this.slimService,
        maxFileSize: "2",
        serviceFormat: "file",
        push: true,
        initialImage: this.value ? this.value.original_url : null,
        crop: this.determineInitialCrop(),
        didRemove: () => this.$emit("input", null)
      }
    };
  },

  methods: {
    determineInitialCrop() {
      if (this.value && this.value.crop) {
        let crop = this.value.crop.split(",");
        // determine the initial crop rectangle based on the input file
        var rect = {
          x: crop[0],
          y: crop[1],
          width: crop[2],
          height: crop[3]
        };

        // return the rectangle back to Slim
        return rect;
      } else {
        return null;
      }
    },

    slimService(data, progress, success, failure, slim) {
      let formdata = new FormData();

      formdata.append(
        "crop",
        `${slim.data.actions.crop.x},${slim.data.actions.crop.y},${slim.data.actions.crop.width},${slim.data.actions.crop.height}`
      );

      formdata.append("original", data[0]);
      formdata.append("cropped", data[1]);

      filesClient
        .store(formdata, {
          headers: {
            "content-type": "multipart/form-data"
          }
        })
        .then(({ data }) => {
          this.$emit("input", data.data.id);
          this.$emit("url", data.data.url);
          success();
        })
        .catch(() => failure());
    },

    loadImage(url) {
      this.$refs.slim.slim.load(url);
    }
  }
};
/*
addTextWatermark(data, ready) {
      // get the drawing context for the output image
      var ctx = data.output.image.getContext("2d");

      ctx.font = "12px sans-serif";

      var x = data.output.width;
      var y = data.output.height;
      var text = ctx.measureText(`© ${this.watermark}`);

      ctx.fillStyle = "rgba(255,255,255,.9)";
      ctx.fillText(`© ${this.watermark}`, x - text.width - 10, y - 10);

      // continue saving the data
      ready(data);
    },*/
</script>
